import React, { Component } from 'react';
import '../../css/pages/home.css';
import moment from 'moment';
import Nav from 'react-bootstrap/esm/Nav';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import iconSprite from '../../assets/icon-sprite.svg';

class LoanCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interest_rate: 0, period: 0, total_interest: 0, loan_amount: '', monthlypayment: 0, startDate: '', schedules: [],
    };
  }

  PMT = (ir, np, pv, fv, type) => {
    /*
    * ir   - interest rate per month
    * np   - number of periods (months)
    * pv   - present value
    * fv   - future value
    * type - when the payments are due:
    *        0: end of the period, e.g. end of month (default)
    *        1: beginning of period
    */
    let pmt; let
      pvif;

    fv || (fv = 0);
    type || (type = 0);

    if (ir === 0) return -(pv + fv) / np;

    pvif = Math.pow(1 + ir, np);
    pmt = ir * (pv * pvif + fv) / (pvif - 1);

    if (type === 1) pmt /= (1 + ir);

    return pmt.toFixed(2);
  }

  computeEndingbalance = (repayment_amount, balance, cum_interest, interest_rate) => {
    const interest = (balance * (interest_rate / 100)).toFixed(2);
    const principal = (repayment_amount - interest).toFixed(2);
    const ending_balance = (balance - principal);
    let cumulative_interest = (parseFloat(interest) + parseFloat(cum_interest)).toFixed(2);
    if (cumulative_interest <= 0) cumulative_interest = 0.00;
    return {
      interest, principal, ending_balance, cumulative_interest,
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleDelimeterChange = (e) => {
    let { value } = e.target;
    value = value.replace(/,/g, '');
    if (typeof Number(value) === 'number' && !isNaN(Number(value))) {
      const formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      this.setState({
        [e.target.name]: formattedValue,
      });
    }
    return null;
  }

  generateRductionBalanceShecdule = (loan_amount, interest_rate, period, start_date) => {
    const repayment_amount = this.PMT((interest_rate / 100), period, +loan_amount);

    let Beginning_balance = loan_amount;
    let cum_interest = 0;
    let total_interest = 0;

    const schedules = [];

    for (let i = 0; i < +period; i += 1) {
      let {
        interest, principal, ending_balance, cumulative_interest,
      } = this.computeEndingbalance(
        repayment_amount, Beginning_balance, cum_interest, interest_rate,
      );
    
      if (+ending_balance <= 1.0) 
        ending_balance = 0.00;
    
      schedules.push({
        PmtNo: (i + 1),
        PaymentDate: moment(start_date, 'YYYY/MM/DD').add(i, 'months').format('MMMM DD, YYYY'),
        BeginninBal: +Beginning_balance,
        ScheduledPayments: +repayment_amount,
        Principal: +principal,
        Interest: +interest,
        EndingBalance: +ending_balance,
        CumulativeInterest: +cumulative_interest,
      });
    
      Beginning_balance = +ending_balance.toFixed(2);
      cum_interest = cumulative_interest;
      total_interest = parseFloat(total_interest) + parseFloat(interest);
    }
    

    this.setState({
      schedules,
      total_interest: +total_interest,
      monthlypayment: +repayment_amount,
    });
  }

  generateFlatRateShecdule = (loan_amount, interest_rate, period, start_date) => {
    const principal = (loan_amount / period).toFixed(2);
    const interest = (loan_amount * interest_rate) / 100;
    let balance = loan_amount + (interest * period);
    const repayment_amount = parseFloat(principal) + parseFloat(interest);
    let total_interest = 0;

    const schedules = [];

    for (let i = 0; i < +period; i += 1) {
      total_interest += interest;

      let ending_balance = (balance - repayment_amount).toFixed(2);

      if (+ending_balance <= 1.0) ending_balance = 0.00;

      schedules.push({
        PmtNo: (i + 1),
        PaymentDate: moment(start_date, 'YYYY/MM/DD').add(i, 'months').format('MMMM DD, YYYY'),
        BeginninBal: +balance,
        ScheduledPayments: +repayment_amount,
        Principal: +principal,
        Interest: +interest,
        EndingBalance: +ending_balance,
        CumulativeInterest: +total_interest,
      });

      balance = (balance - repayment_amount).toFixed(2);
    }

    this.setState({
      schedules,
      total_interest: +total_interest,
      monthlypayment: +repayment_amount,
    });
  }

  generateInterestOnlyShecdule = (loan_amount, interest_rate, period, start_date) => {
    const interest = (loan_amount * interest_rate) / 100;
    let balance = loan_amount + (interest * period);
    let total_interest = 0;

    const schedules = [];

    for (let i = 0; i < +period; i += 1) {
      const principal = i === period - 1 ? (+loan_amount).toFixed(2) : 0;
      const repayment_amount = i === period - 1 ? (+interest + +principal) : parseFloat(interest);
      
      total_interest += interest;

      let ending_balance = (balance - repayment_amount).toFixed(2);

      if (+ending_balance <= 1.0) ending_balance = 0.00;

      schedules.push({
        PmtNo: (i + 1),
        PaymentDate: moment(start_date, 'YYYY/MM/DD').add(i, 'months').format('MMMM DD, YYYY'),
        BeginninBal: +balance,
        ScheduledPayments: +repayment_amount,
        Principal: +principal,
        Interest: +interest,
        EndingBalance: +ending_balance,
        CumulativeInterest: +total_interest,
      });

      balance = (balance - repayment_amount).toFixed(2);
    }

    this.setState({
      schedules,
      total_interest: +total_interest,
      monthlypayment: +0,
    });
  }

  computeSchedule = () => {
    const {
      loan_amount, interest_rate, period, scheduleType,
    } = this.state;

    let { startDate } = this.state;
    if (!startDate) startDate = moment().format('YYYY/MM/DD');

    const amount = parseFloat(loan_amount.replace(/,/g, ''));
    if (scheduleType === 'flat') {
      this.generateFlatRateShecdule(amount, +interest_rate, +period, startDate);
    } else if (scheduleType === 'reducing') {
      this.generateRductionBalanceShecdule(amount, +interest_rate, +period, startDate);
    } else if (scheduleType === 'interest only') {
      this.generateInterestOnlyShecdule(amount, +interest_rate, +period, startDate);
    }
  }

  render() {
    const {
      schedules, monthlypayment, period, total_interest,
    } = this.state;
    return (
      <>
        <SideNav page="calculator" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="calculator" />
            <section className="body-main__content">
              <div className="home">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Hello,&nbsp;</h3>
                  <p className="pageTitle__subheader">Welcome back!</p>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="interest_method" className="form-label">Interest Method</label>
                      <div className="input-with-icon">
                        <select
                          className="form-control"
                          id="scheduleType"
                          name="scheduleType"
                          onChange={this.handleOnChange}>
                          <option value="">Select schedule type</option>
                          <option value="flat">Flat Rate</option>
                          <option value="reducing">Reducing Balance</option>
                          <option value="interest only">Interest only</option>
                        </select>
                        <span className="input-icon">
                          <svg width="24" height="24">
                            <use xlinkHref={`${iconSprite}#dropdown`}></use>
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="loan_amount" className="form-label">Loan amount</label>
                      <input
                        type="text"
                        className="form-control"
                        id="loan_amount"
                        name="loan_amount"
                        onChange={this.handleDelimeterChange}
                        required />
                    </div>
                    <div className="form-group">
                      <label htmlFor="interest_rate" className="form-label">Monthly Interest Rate</label>
                      <input
                        type="number"
                        className="form-control"
                        id="interest_rate"
                        name="interest_rate"
                        onChange={this.handleOnChange}
                        required />
                    </div>
                    <div className="form-group">
                      <label htmlFor="period" className="form-label">Loan Period in Months</label>
                      <input
                        type="number"
                        className="form-control"
                        id="period"
                        name="period"
                        onChange={this.handleOnChange}
                        required />
                    </div>
                    <div className="form-group">
                      <label htmlFor="startDate" className="form-label">First Repayment Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="startDate"
                        name="startDate"
                        onChange={this.handleOnChange}
                        required />
                    </div>
                    <button className="btn btn-primary btn-block btn-sm float-right" type="button" onClick={() => this.computeSchedule()}>Calculate Loan Schedule</button>
                    <br /><br />
                  </div>
                  
                  <div className="col-md-6">
                    <div className="table-responsive">
                      <table>
                        <thead>
                          <tr>
                            <th colSpan="2" style={{ textAlign: 'center', paddingBottom: '20px' }}>Loan Summary</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ marginBottom: '5px' }}>
                            <td VALIGN="TOP">Scheduled Payment</td>
                            <td>
                              <input type="text" className="form-control" style={{ textAlign: 'right', height: '35px' }} value={monthlypayment.toLocaleString()} />
                              <br />
                            </td>
                          </tr>
                          <tr>
                            <td VALIGN="TOP">Scheduled Number of Payments</td>
                            <td>
                              <input type="number" className="form-control" style={{ textAlign: 'right', height: '35px' }} value={period} />
                              <br />
                            </td>
                          </tr>
                          <tr>
                            <td VALIGN="TOP">Actual Number of Payments</td>
                            <td>
                              <input type="number" className="form-control" style={{ textAlign: 'right', height: '35px' }} value={schedules.length} />
                              <br />
                            </td>
                          </tr>
                          <tr>
                            <td VALIGN="TOP">Total Interest</td>
                            <td>
                              <input type="text" className="form-control" style={{ textAlign: 'right', height: '35px' }} value={total_interest.toLocaleString()} />
                              <br />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col">
                    <div className="card default-card settings">
                      <Nav
                          className="nav nav-tabs"
                          as="ul">
                        <Nav.Item as="li" className="nav-item">
                          <Nav.Link className="nav-link active" eventKey="profile">
                            Loan Repayment Schedule
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <div className="tab-content">
                        <div className="tab-pane fade show active">
                          <div className="table-responsive">
                            <table className="table">
                              <thead className="bg-secondary">
                                <tr>
                                  <th className="reference text-white">Pmt No</th>
                                  <th className="amount text-white">Payment Date</th>
                                  <th className="amount text-white">Beginning Balance</th>
                                  <th className="narration text-white">Principal</th>
                                  <th className="narration text-white">Interest</th>
                                  <th className="amount text-white">Amount Due</th>
                                  <th className="narration text-white">Cumulative Interest</th>
                                  <th className="narration text-white">Principal Balance</th>
                                </tr>
                              </thead>
                              <tbody>
                                {schedules.map((m) => (
                                  <tr key={m.PmtNo}>
                                    <td className="text-center">{m.PmtNo}</td>
                                    <td>{m.PaymentDate}</td>
                                    <td>{m.BeginninBal.toLocaleString()}</td>
                                    <td>{m.Principal.toLocaleString()}</td>
                                    <td>{m.Interest.toLocaleString()}</td>
                                    <td>{m.ScheduledPayments.toLocaleString()}</td>
                                    <td>{m.CumulativeInterest.toLocaleString()}</td>
                                    <td>{m.EndingBalance.toLocaleString()}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default LoanCalculator;
